import styled from "styled-components";
import { SpacingStyle, getMarginStyle, getPaddingStyle } from "core/styles/paddingMarginStyle";
import { AlertVariant } from ".";
import { css } from "styled-components";

export const Container = styled.div<{ variant?: AlertVariant } & SpacingStyle>`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-left: 4px solid ${({ theme }) => theme?.colors?.warningv2.border};
  border-radius: 5px;
  background-color: ${({ theme }) => theme?.colors?.warningv2.subtlest};

  ${({ variant }) => {
    if (variant === "primary")
      return css`
        border-left: 4px solid ${({ theme }) => theme?.colors?.primary.border};
        background-color: ${({ theme }) => theme?.colors?.primary.surface};

        path {
          fill: ${({ theme }) => theme?.colors?.primary.default};
        }
      `;

    return css`
      border-left: 4px solid ${({ theme }) => theme?.colors?.warningv2.border};
      background-color: ${({ theme }) => theme?.colors?.warningv2.subtlest};
    `;
  }}

  ${getMarginStyle}
  ${getPaddingStyle}
`;
